import React, {useState} from 'react'
import {ApiKey, razorpayURL, RazorpayAPIkey, paymentUrl, paymentverificationUrl} from '../config.js'
import axios from 'axios';
import './Subscribe.css'



const featuresData = [
  {
    "section": "Content",
    "features": [
      {
        "name": "NCERTs (Explained, Originals)",
        "description": "Provides curated explanations and original text",
        "free": "available",
        "premium": "available"
      },
      {
        "name": "360° Notes",
        "description": "GS1, GS2, GS3 and GS4 - Concise, organised & interconnected notes for quick, holistic understanding, reducing the need for multiple sources",
        "free": "not-available",
        "premium": "available"
      },
      {
        "name": "PYQ Solved (Mains)",
        "description": "Expertly solved answers with insights",
        "free": "not-available",
        "premium": {
                  "text" : "Last 10 years"
                  }
      },
      {
        "name": "Essay Module",
        "description": "Includes structured frameworks, samples, tips",
        "free": "not-available",
        "premium": "available"
      },
      {
        "name": "MCQ Module",
        "description": "Practice and exam modes designed following UPSC patterns closely",
        "free": {
          "text": "Only one mock text"
        },
        "premium": {
          "text": "Unlimited mock texts"
        }
      }
    ]
  },
  {
    "section": "Learning Tools",
    "features": [
      {
        "name": "Highlight",
        "description": "Digital highlighting for easy revision",
        "free": "available",
        "premium": "available"
      },
      {
        "name": "Comment",
        "description": "Personalized annotations",
        "free": "available",
        "premium": "available"
      },
      {
        "name": "Craft Notes",
        "description": "Better organization & portability",
        "free": "available",
        "premium": "available"
      },
      {
        "name": "Revision Scheduler",
        "description": "Prioritize and track revisions systematically",
        "free": "available",
        "premium": "available"
      },
      {
        "name": "Search",
        "description": "Quickly search content",
        "free": "available",
        "premium": "available"
      }
    ]
  },
  {
    "section": "Annual Subscription",
    "features": [
      {
        "name": "Cost",
        "description": "for one year",
        "free": {
           "text" : "free"
        },
        "premium": {
          "text" : "₹9999"
          }
      }
    ]
  }
];


export default function Subscribe({msg, backToLogin}) {
  let data;
  const [rpayloading, setrpayLoading] = useState(false);
  function PaymentSuccessHandler(response){
    /*alert(response.razorpay_payment_id);
    alert(response.razorpay_order_id);
    alert(response.razorpay_signature);*/
    response['Callfrom'] = 'ClientHandler';
    response['Username'] = localStorage.getItem('user');
    response['OrderId'] = data.order_id;
    axios.post(paymentverificationUrl, response).then(resp => {
      // todo:: use modal component present here. 
     // https://github.com/machadop1407/React-Modal-Tutorial
     console.log(resp);
     alert(resp.data.message);
     backToLogin("Please login");
   }).catch(err => {
     alert(err);
     backToLogin(err);
    });
  }
  function PaymentFailureHandler(response)
  {
    /*alert(response.error.code);
    alert(response.error.description);
    alert(response.error.source);
    alert(response.error.step);
    alert(response.error.reason);
    alert(response.error.metadata.order_id);
    alert(response.error.metadata.payment_id);*/
    alert(response.error.code +" : " + response.error.description);
  }

  async function displayRazorPay(e, accessType)
    {
      e.preventDefault();
      if (rpayloading) return; // 🚫 block if already processing
      const razorpayScript = await loadRazorPay();
      if(!razorpayScript)
        {
        alert('Failed to load payment gateway');
        return;
        }
        //Todo:: custom buy option.
        var req = {
          email: localStorage.getItem('user'),
          accessType: accessType
        };
        
        const headers = { 
          'x-api-key': ApiKey
        };
        setrpayLoading(true);
        axios.post(paymentUrl, req, { withCredentials: true, headers:headers}).then(resp => {
           // todo:: use modal component present here. 
          // https://github.com/machadop1407/React-Modal-Tutorial
          data = resp.data;
          var options = {
            "key": RazorpayAPIkey, 
            "amount": data.amount, 
            "currency": data.currency,
            "name": "Civilscode",
            "description": "Full Access",
            "image": process.env.PUBLIC_URL + '/logo.svg',
            "order_id": data.order_id, 
            "handler": PaymentSuccessHandler,
            "prefill": {
                "email": localStorage.getItem['user']
              },
            "theme": {
                "color": "#4cbf6a"
            }
        }; 
        var rzpl = new window.Razorpay(options);
        rzpl.on('payment.failed', PaymentFailureHandler);
        rzpl.open();
          alert("Please make a note of this order id: " + data.order_id);
        }).catch(err => { alert(err.response.data.message); }).finally(() => {
          setrpayLoading(false); // re-enable button after completion
        });;
        
    }
  function loadRazorPay() {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = razorpayURL;
      script.async = true;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      }
      document.body.appendChild(script);
    });
    }
  return (
    <div className="SubscriptionWarning">
      <div className="table-container">
      <table className="comparison-table">
        <thead>
          <tr>
            <th>Features</th>
            <th className='CenterStatus'>Free <br/> (1 Year)</th>
            <th className='CenterStatus'>Premium <br/> (1 Year)</th>
          </tr>
        </thead>
        <tbody>
          {featuresData.map((section) => (
            <>
              <tr key={section.section}>
                <td className="section-heading" colSpan="3">{section.section}</td>
              </tr>
              {section.features.map((feature) => (
                <tr key={feature.name}>
                  <td>
                    <h5>{feature.name}</h5>
                    {feature.description}
                  </td>
                  <td className="CenterStatus">
                    {feature.free.text==null 
                      ? <span className={`status ${feature.free}`}></span>
                      : feature.free.text}
                  </td>
                  <td className="CenterStatus">
                    {feature.premium.text==null 
                      ? <span className={`status ${feature.premium}`}></span>
                      : feature.premium.text}
                  </td>
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </table>
    </div>
    <div className='Subscribe'>
      <span>
      {msg}
      <div className="flex flex-col md:flex-row gap-4 items-center justify-center mt-6">
        <form onSubmit={(e) => { displayRazorPay(e, "month"); }}>
          <button
            type="submit" disabled={rpayloading}
            className="SubscribeBtn px-4 py-2 bg-[var(--highlightgreen)] hover:shadow-[6px_6px_0px_var(--bgopposite2)] shadow-md text-center rounded-lg hover:translate-y-[-5px] 
               transition-all duration-300 ease-in-out"
          >
            <div className="flex flex-col items-center">
              {rpayloading && ( <div className="h-5 w-5 border-2 border-[var(--highlightgreen)] border-t-transparent rounded-full animate-spin"></div> )}
              <span>Give It a Go – 1 Month 🔓 </span>
              <span className="text-sm text-[var(--textongreen)]/90 mt-1">(₹999)</span>
            </div>
          </button>
        </form>

        <form onSubmit={(e) => { displayRazorPay(e, "year"); }}>
          <button
            type="submit" disabled={rpayloading}
            className="SubscribeBtn px-4 py-2 bg-[var(--highlightgreen)] text-[var(--textongreen)] hover:shadow-[6px_6px_0px_var(--bgopposite2)] shadow-md text-center rounded-lg hover:translate-y-[-5px] 
               transition-all duration-300 ease-in-out"
          >
            <div className="flex flex-col items-center">
            {rpayloading && ( <div className="h-5 w-5 border-2 border-[var(--highlightgreen)] border-t-transparent rounded-full animate-spin"></div> )}
              <span>Go Elite – 1 Year Access 🎯</span>
              <span className="text-sm text-[var(--textongreen)]/90 mt-1">(₹9999)</span>
            </div>
          </button>
        </form>
</div>
      </span>
 
      </div>
      </div>
  )
}
